export default __webpack_public_path__ + "static/media/split_img1.82dacc80.svg";